module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locked-mask"
  }, [_c('div', {
    staticClass: "mask-message"
  }, [_c('h5', [_vm._v("目前前台登入中的使用者")]), _c('hr'), _vm._l((_vm.loginedUsers), function(user) {
    return _c('div', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(_vm._s(user.username) + " ")]), (user.first_name || user.last_name) ? _c('span', [_vm._v("(" + _vm._s(user.last_name) + " " + _vm._s(user.first_name) + ")")]) : _vm._e()])
  }), _c('hr'), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("請等待前台操作完畢")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0e6274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/LockedMask.vue
// module id = 1377
// module chunks = 1